<template>
    <v-form-item
        name="replyImgTxt"
        label="图文消息"
        required="请选择"
        :rules="rules"
        @error="handlerError"
    >
        <div class="flex">
            <v-input
                :value="showContent"
                :clearable="false"
                @click.native="chooseImg"
                name="replyImgTxt"
                placeholder="请选择"
                readonly
                class="img-txt-trigger"
            >
                <template slot="right-icon">
                    <v-icon
                        name="arrow_down_small_line"
                        remote
                    />
                </template>
            </v-input>

            <template v-if="showContent">
                <v-button
                    v-tip:imgtxtPreview.hover
                    type="link"
                    kind="primary"
                >
                    预览
                </v-button>

                <!-- 预览气泡 -->
                <v-tip
                    ref="imgtxtPreview"
                    placement="top-end"
                    clazz="imgtxt-preview-tip"
                >
                    <waterfall-item
                        :item="currentValue"
                        :coords="{}"
                        :selected="{}"
                        :readonly="true"
                    />
                </v-tip>
            </template>
        </div>

        <!-- 图文选择器 -->
        <imgtxt-panel
            v-model="currentValue"
            :show.sync="isShowSelectPanel"
        />
    </v-form-item>
</template>

<script>
import ImgtxtPanel from './imgtxt-panel';
import WaterfallItem from './waterfall-item';
import errorMixin from '../errorMixin';

export default {
    mixins: [errorMixin],
    components: {
        ImgtxtPanel,
        WaterfallItem,
    },
    props: {
        value: {
            type: String,
            default: {},
        },
    },
    data() {
        return {
            currentValue: this.value || {},
            isShowSelectPanel: false,
            rules: [{
                validate: (val, rule) => {
                    return this.$ajax.get(`/mp/rest/imgTxtMaterial/${this.currentValue.materialId}`)
                        .then((res) => {
                            if (res.id === -1) {
                                throw new Error(rule.message);
                            }

                            return true
                        });
                },
                message: '素材已被删除，请重新选择',
                trigger: 'input,submit',
            }],
        };
    },
    computed: {
        showContent() {
            const { articles } = this.currentValue || {};
            if (articles) {
                return articles[0].title;
            }

            return '';
        },
    },
    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        },
    },

    methods: {
        chooseImg() {
            this.isShowSelectPanel = true;
        },
    },
};
</script>

<style lang="less" scoped>
.flex{
    display: flex;
}
.img-txt-trigger{
    flex: 1;
    cursor: pointer;
    /deep/input{
        cursor: pointer;
    }
    margin-right: var(--spacing-base);

    .v-icon{
        color: var(--color-text-caption);
    }
}
</style>

<style lang="less">
.imgtxt-preview-tip{
    .waterfall-item{
        position: relative;
        margin: 0;
    }
}
</style>
